import { Component, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  FormGroup,
  FormControl
} from '@angular/forms';
import { Nomenclature } from 'src/app/shared/models/nomenclature';
import { RequestService } from 'src/app/core/services/request.service';
import { FormErrorsService } from 'src/app/core/services/form-errors.service';
import { Observable } from 'rxjs';
import { FormGroupService } from 'src/app/core/services/form-group.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AddressComponent implements OnInit {
  parentFormGroup: FormGroup;
  areasNomenclature$: Observable<Nomenclature[]>;
  citiesNomenclature$: Observable<Nomenclature[]>;

  constructor(
    private formGroupDirective: FormGroupDirective,
    private formGroupService: FormGroupService,
    private requestService: RequestService,
    private formErrorsService: FormErrorsService
  ) {
    this.areasNomenclature$ = this.requestService.getAreasNomenclature();
  }

  ngOnInit() {
    this.parentFormGroup = this.formGroupDirective.form;
    this.parentFormGroup.addControl(
      'address',
      this.formGroupService.buildAddressForm()
    );

    this.parentFormGroup
      .get('address')
      .get('state')
      .valueChanges.subscribe(state => {
        this.changeState(state);
      });

    this.parentFormGroup
      .get('address')
      .get('city')
      .valueChanges.subscribe(city => {
        this.changeCity(city);
      });
  }

  public getError(fc: FormControl) {
    return this.formErrorsService.getErrorMessages(fc);
  }

  changeState(stateId: string) {
    this.parentFormGroup
      .get('address')
      .get('postCode')
      .setValue('');

    this.citiesNomenclature$ = this.requestService.getCitiesNomenclature(
      Number(stateId)
    );
  }

  changeCity(cityId: string) {
    const stateId = this.parentFormGroup.get('address').get('state').value;

    // TODO да се направи с Pipe
    this.requestService.getPostCode(stateId, cityId).subscribe((item: any) => {
      if (item.length > 0) {
        this.parentFormGroup
          .get('address')
          .get('postCode')
          .setValue(item[0].zip);
      }
    });
  }

  get address() {
    return this.parentFormGroup.get('address') as FormControl;
  }

}
